import { CUSTOMER_LANE_COMMITMENTS } from '../../constants';

export const DATA_TYPE = CUSTOMER_LANE_COMMITMENTS;
